import { setSnackbarMessage } from './snackbarAction';
import { isEditingInProgress } from './AppAction';

export const reportsTypesFetched = (items) => { 
	return { 
		type: 'REPORTS_TYPES_FETCHED', 
		payload: items 
	}
}

export const addReport = (url, reportData, files) => {
	let data = new FormData();
	data.append("report_type", reportData.reportType.value);
	data.append("mydp_user_id", reportData.user.user_id);
	data.append("dp_address_id", JSON.stringify(reportData.selectedAddresses));
	data.append("selected_values", JSON.stringify(reportData.attached_values));
	data.append("report_files", JSON.stringify(files));
	
	if(reportData.selectedRepetitive)
	{
		data.append('repetitive', reportData.selectedRepetitive);
	}

	return (dispatch) => {

		dispatch(isEditingInProgress('addReport',true));
		fetch(url,
		{
			method: "POST",
			body: data
		})
		.then((response) => {
			if(!response.ok) {
				throw Error(response.statusText);
			}

			return response;
		})
		.then((response) => response.json())
		.then((items) => {
			
			let decoded = JSON.parse(items);
			dispatch(isEditingInProgress('addReport',false));
			if(decoded.message) {
				dispatch(setSnackbarMessage(decoded.message));
			}
			
		})
		.catch(() => {
//			console.log("ERRORED IN CATCH");
			dispatch(isEditingInProgress('addReport',false));
		});
	}
}


//-- This action fetches the routes based on a user ID
export const getReportTypes = (url, user_id = false) => {
	let data = new FormData();
	data.append('user_id', user_id);

	return (dispatch) => {
		fetch(url,
		{
			method: "POST",
			body: data
		})
		.then((response) => {
			if (!response.ok) {
				throw Error(response.statusText); 
			}

			return response;
		})
		.then((response) => response.json())
		.then((items) => {
			if(!items.error_message) {
				dispatch(reportsTypesFetched(items))
			}else{
				dispatch(setSnackbarMessage(items.error_message));
			}

		})
		.catch(() => {
			dispatch(setSnackbarMessage('Er heeft zich een fout voorgedaan tijdens het laden van de rapportagetypes'));
		});
	};
}

//-- This action fetches the routes based on a user ID
export const setRepetativeActive = (url, report_id, user_id) => {
	let data = new FormData();
	data.append('user_id', user_id);
	data.append('report_id', user_id);
	
	
	return (dispatch) => {
		fetch(url,
		{
			method: "POST",
			body: data
		})
		.then((response) => {
			if (!response.ok) {
				throw Error(response.statusText);
			}

			return response;
		})
		.then((response) => response.json())
		.then((items) => {
			const decoded = JSON.parse(items);
			
			dispatch(setSnackbarMessage(decoded.message));

		})
		.catch(() => {
			dispatch(setSnackbarMessage('Er heeft zich een fout voorgedaan tijdens het laden van de rapportagetypes'));
		});
	};
}


// WEBPACK FOOTER //
// ./src/redux/actions/reportAction.js